/* src/app/admin-dashboard/planner/planner.component.css */
.example-headers-align .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
}
.example-headers-align .mat-mdc-form-field + .mat-mdc-form-field {
  margin-left: 8px;
}
/*# sourceMappingURL=planner.component.css.map */
